// extracted by mini-css-extract-plugin
export var buttons = "featured-jobs-module--buttons--91954";
export var carousel = "featured-jobs-module--carousel--2ad74";
export var root = "featured-jobs-module--root--78424";
export var title = "featured-jobs-module--title--5ad2e";